import React, { FunctionComponent } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'rootReducer';
import { IconButton } from '../Buttons/IconButton';
import { useAudioPosition } from 'features/audio/useAudioPosition';

export const ForwardButton: FunctionComponent = () => {
  const { seek } = useAudioPosition();
  const loading = useSelector((state: RootState) => state.audio.loading);
  const currentTime = useSelector(
    (state: RootState) => state.audio.currentTime
  );

  const onClick = () => {
    seek(currentTime + 15);
  };

  return (
    <IconButton
      label={'Fast Foward 15 seconds'}
      onClick={onClick}
      isDisabled={loading}
      icon={'forward15'}
    />
  );
};
